import React from 'react';

import Icon from '../Icon/Icon';

const IconToLeft = (props) => {
    return (
        <Icon width='32' height='32' fill='None' {...props}>
            <rect x='0.5' y='0.515625' width='31' height='31' rx='15.5' stroke='currentColor' />
            <path d='M17.9363 11.0156L13.0808 15.8543' stroke='currentColor' strokeLinecap='round' />
            <path d='M13.0808 15.8545L17.9363 20.71' stroke='currentColor' strokeLinecap='round' />
        </Icon>
    );
};

export default IconToLeft;
